module.exports = __webpack_public_path__ + "img/ppr-horiz-200.14d6f099.svg";